'use client';

import { useEffect } from 'react';
import { reloadOnceOnChunkError } from '@/lib/chunk-error-reload';

export default function GlobalError({
    error,
    reset,
}: {
    error: Error & { digest?: string };
    reset: () => void;
}) {
    useEffect(() => {
        console.error('[global-error]', error);
        // A stale deployment or a dropped chunk request on a flaky network is
        // the most common cause of this screen on mobile — hard reload once.
        reloadOnceOnChunkError(error);
    }, [error]);

    return (
        <html lang="zh-CN">
            <body style={{ margin: 0, fontFamily: 'system-ui, -apple-system, sans-serif' }}>
                <div
                    style={{
                        minHeight: '100svh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '#f8fafc',
                        padding: '24px',
                    }}
                >
                    <div
                        style={{
                            maxWidth: '420px',
                            width: '100%',
                            background: '#ffffff',
                            border: '1px solid #e2e8f0',
                            borderRadius: '16px',
                            padding: '32px 24px',
                            textAlign: 'center',
                        }}
                    >
                        <h1 style={{ fontSize: '18px', fontWeight: 600, color: '#0f172a', margin: '0 0 8px' }}>
                            页面出错了 / Something went wrong
                        </h1>
                        <p style={{ fontSize: '13px', color: '#64748b', margin: '0 0 20px', wordBreak: 'break-word' }}>
                            {error.message || '未知错误 / Unknown error'}
                        </p>
                        {error.digest && (
                            <p style={{ fontSize: '11px', color: '#94a3b8', margin: '0 0 20px' }}>
                                Digest: {error.digest}
                            </p>
                        )}
                        <button
                            onClick={reset}
                            style={{
                                background: '#10b981',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '10px',
                                padding: '10px 24px',
                                fontSize: '14px',
                                fontWeight: 500,
                                cursor: 'pointer',
                            }}
                        >
                            重试 / Try again
                        </button>
                    </div>
                </div>
            </body>
        </html>
    );
}
